import { render, staticRenderFns } from "./Backups.vue?vue&type=template&id=39f61d70&scoped=true"
import script from "./Backups.vue?vue&type=script&lang=js"
export * from "./Backups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f61d70",
  null
  
)

export default component.exports